module.exports = __webpack_public_path__ + "static/media/wukong study 6pics.31b4b984.png";